  import { Component, OnInit } from '@angular/core';
  import { ActivatedRoute } from '@angular/router';
  import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';
  import { Subscription } from 'rxjs/Subscription';
  import {NgbProgressbarConfig} from '@ng-bootstrap/ng-bootstrap';

  import {Subject} from 'rxjs';
  import {debounceTime} from 'rxjs/operators';
  import { PersonSummary, CommonUtility,Appointment, WpPerson} from '../shared';

  import { DateUtility, ServerConstantsService } from '../shared';
  import { ReferenceTableService } from '../reference-table.service';
  import { DataService } from '../shared';
  import { NotificationsService } from 'angular2-notifications';


  @Component({
    selector: 'app-person-summary',
    templateUrl: './person-summary.component.html',
    styleUrls: ['./person-summary.component.scss'],
    providers: [NgbProgressbarConfig]
  })
  export class PersonSummaryComponent implements OnInit {

    programs: any;
    isUniverse = false;
    private _danger = new Subject<string>();
    errorMessage: string;
    referralId: string = '';
    wpPersonId: string = '';
    personSummary: PersonSummary;
    volParticipation: any;
    refData: any;
    programsMap: any;
    volParticipationMap: any;
    appointmentTypeMap: any;
    userActionNotificationsMap: any;
    appointmentType: any;
    ServerConstants: any;
    sharedData: any;
    ssnConstant: any;

    constructor(
      private route: ActivatedRoute,
      private http: HttpClient,
      config: NgbProgressbarConfig,
      private dateUtil: DateUtility,
      private data: ReferenceTableService,
      private commonUtil: CommonUtility,
      public dataService: DataService,
      private notificationService: NotificationsService,
      private serverConstantsService: ServerConstantsService,
    ) {
      this.ServerConstants = serverConstantsService.getConstants();
      config.height = '20px';
    
    }

    ngOnInit() {
      this.sharedData = this.dataService.getSharedDataObject();
      /* set global values for page */
      this.ssnConstant = this.sharedData.get('SSN_CONSTANT');
      this.isUniverse = this.sharedData.get('UNIVERSE_SEARCH');
      console.log(this.ssnConstant);
      this.referralId = this.sharedData.get('referralId');
      this.wpPersonId = this.sharedData.get('wpPersonId');
      this.data.currentMessage.subscribe(
      (message) => {
          this.refData = message;
          this.parseRefTableData(message);
      });
      this.load();
      /* error message */
      this._danger.subscribe((message) => this.errorMessage = message);
      this._danger.pipe(
        debounceTime(5000)
      ).subscribe(() => this.errorMessage = null);
    }

    load( ){
        this.http.post<PersonSummary>(this.ServerConstants.COMMON_SERVER_API_URL + '/personsummary/load' , {"referralId" :this.referralId, "personId": this.wpPersonId} ).subscribe(
          (data: PersonSummary ) => {
            if(data.hasOwnProperty('errorCode')){
                this.notificationService.error('Person', this.userActionNotificationsMap.ERROR);
                this.personSummary = new PersonSummary();
            }else{
              /* Always get the first appointment to display*/
             

              this.personSummary = data;

              if (this.personSummary.enrollmentStartDt != null){
                  this.personSummary.enrollmentStartDt = this.dateUtil.convertDateFromServer(this.personSummary.enrollmentStartDt);
              }
              if (this.personSummary.enrollmentEndDt != null){
                  this.personSummary.enrollmentEndDt = this.dateUtil.convertDateFromServer(this.personSummary.enrollmentEndDt);
              }

              if (this.personSummary.referredDt != null){
                  this.personSummary.referredDt = this.dateUtil.convertDateFromServer(this.personSummary.referredDt);
              }
              if (this.personSummary.orientationDt != null){
                  this.personSummary.orientationDt = this.dateUtil.convertDateFromServer(this.personSummary.orientationDt);
              }
              if (this.personSummary.assessmentDt != null){
                this.personSummary.assessmentDt = this.dateUtil.convertDateFromServer(this.personSummary.assessmentDt);
            }
       
             if ( this.personSummary.programCd != null ){
                    this.personSummary.programCd = this.convertCode( this.programsMap,this.personSummary.programCd);
             }

            if ( this.personSummary.etRegInd != null ){
              this.personSummary.etRegInd = this.convertCode( this.volParticipationMap,this.personSummary.etRegInd);
            }
            const appointment = new Appointment();
            // Set task object to the apppointment object
           
            appointment.wpPerson = new WpPerson();
            appointment.wpPerson.id=parseInt(this.wpPersonId);
            this.http.post<Appointment[]>(this.ServerConstants.SERVER_API_URL + '/appointment/loadHistory' , appointment ).subscribe(
              (appointments: Appointment[] ) => {
                if(appointments!=null && appointments.length>0)
                {
                  const appObj=appointments[appointments.length-1];
                  if (appObj.appointmentDt != null){
                    this.personSummary.appointmentDt = this.dateUtil.convertDateFromServer(appObj.appointmentDt);
                }
                
                if ( appObj.appointmentDt != null ){
                   this.personSummary.appointmentType = this.convertCode( this.appointmentTypeMap,appObj.appointmentType);
                }
              }
              });

           }

          },
          response => {
              this.notificationService.error('Person', this.userActionNotificationsMap.ERROR);
          },
          () => {
          });


         
      }

      

    parseRefTableData(myData){
      if(myData != undefined && myData.englishDropDown){
          this.volParticipation = myData.englishDropDown["mandatoryVoluntaryParticipation"];
          this.programs = myData.englishDropDown["PROGRAMS"];
          this.appointmentType = myData.englishDropDown["appointmentType"];
          this.volParticipationMap = this.commonUtil.createMapFromList(this.volParticipation);
          this.programsMap = this.commonUtil.createMapFromList(this.programs);
          this.appointmentTypeMap = this.commonUtil.createMapFromList(this.appointmentType);
          this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(myData.englishDropDown["USER-ACTION-NOTIFICATIONS"]);
      }
    }

    convertCode(myMap, code){
      if(myMap != undefined){
        return myMap.get(code);
      }
    }
  }



// WEBPACK FOOTER //
// ./src/app/person-summary/person-summary.component.ts